<ng-container>
  <isophi-app-portfolio-plan-base-item
    #base
    *transloco="let t"
    [leftIcon]="'image'"
    [rightIcon]="'add_2'"
    [title]="t('portfolio/photos')"
    [shared]="recordTypeEnum.Private"
    [onCardClick]="openFileInput.bind(this)"
  >
    <div class="row" *ngIf="photos.length > 0">
      <div class="col-md-4 col-6 pb-3 px-2 px-sm-3 pb-sm-5" *ngFor="let photo of photos">
        <a [href]="photo.file" target="_blank">
          <div class="image-card" [style.background-image]="getBackgroundImageUrl(photo)">
            <div class="photo-actions">
              <div class="photo-action-icon" [title]="t('portfolio/rename')" (click)="handleRenamePhoto(photo, $event)">
                <span class="material-symbols-rounded text-white"> edit </span>
              </div>
              <div class="photo-action-icon" [title]="t('portfolio/delete')" (click)="handleDeletePhoto(photo.id, $event)">
                <span class="material-symbols-rounded text-white"> delete </span>
              </div>
            </div>
          </div>
        </a>
        <div class="photo-title" [title]="getFileDisplayName(photo)">{{ getFileDisplayName(photo) }}</div>
      </div>
    </div>
  </isophi-app-portfolio-plan-base-item>
  <input #fileInput type="file" accept="image/*" hidden (change)="handleFileChange($event)" />
</ng-container>
